import * as Sentry from '@sentry/react';
import { CssBaseline, ThemeProvider, Theme, StyledEngineProvider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import theme from 'config/theme';
import GlobalStateContainer from 'containers/global_state_container';
import { adminRoutes } from './routes/admin';
import { mypageRoutes } from './routes/mypage';
import { partnerRoutes } from './routes/partner';
import { staticRoutes } from './routes/static_page';
import SidebarContainer from 'containers/sidebar_container';
import ja from 'date-fns/locale/ja';
import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import '@mui/styles';
// eslint-disable-next-line no-restricted-imports
import './App.scss';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

export const appTitle = 'リプルア機器管理';

function App() {
  const queryClient = new QueryClient();

  const routes = [...adminRoutes, ...mypageRoutes, ...partnerRoutes, ...staticRoutes];
  const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
  const router = sentryCreateBrowserRouter(routes);

  return (
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Helmet title={`${appTitle}`} />
            <RecoilRoot>
              <GlobalStateContainer>
                <SidebarContainer>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
                    <RouterProvider router={router} future={{ v7_startTransition: true }} />
                  </LocalizationProvider>
                </SidebarContainer>
              </GlobalStateContainer>
            </RecoilRoot>
          </ThemeProvider>
        </QueryClientProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  );
}

export default App;
